import { render } from "./HomeAbousUsSection.vue?vue&type=template&id=4632413e&scoped=true"
import script from "./HomeAbousUsSection.vue?vue&type=script&lang=js"
export * from "./HomeAbousUsSection.vue?vue&type=script&lang=js"

import "./HomeAbousUsSection.vue?vue&type=style&index=0&id=4632413e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4632413e"]])

export default __exports__